import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import * as locales from '@mui/material/locale';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import { useUserContext } from '../user';

const ThemeContextProvider = ({ children }) => {
  const { locale } = useUserContext();

  const theme = useMemo(
    () => createTheme({
      palette: {
        primary: {
          main: '#2845D2',
        },
      },
      typography: {
        fontFamily: [
          'Inter',
        ],
        WebkitTextSizeAdjust: '100%',
        fontVariantLigatures: 'none',
        WebkitFontVariantLigatures: 'none',
        textRendering: 'optimizeLegibility',
        MozOsxFontSmoothing: 'grayscale',
        fontSmoothing: 'antialiased',
        WebkitFontSmoothing: 'antialiased',
        textShadow: 'rgba(0, 0, 0, .01) 0 0 1px',
      },
    }, locales[locale]),
    [locale],
  );

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
};

ThemeContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ThemeContextProvider;
